// DO NOT CHANGE
// Compiled by gulp ngtemplates:module. Adds templates to $templateCache.

/* jshint ignore:start */
angular.module("saturn.dropdown").run(["$templateCache", function($templateCache) {$templateCache.put("saturn/dropdown/dropdown.tpl.html","<div class=\"dropdown\" \n  ng-class=\"{open: dropdownCtrl.show}\" \n  ng-transclude>\n</div>");}]);
/* jshint ignore:end */


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dropdown/src/templates.js